import React, {useEffect} from 'react';
import {PaymentCard, valid} from 'baseui/payment-card';
import {Input} from 'baseui/input';
import {Label2} from 'baseui/typography';
import {Button} from 'baseui/button';
import {MaskedInput} from 'baseui/input';
import {FormControl} from 'baseui/form-control';
import {useStyletron} from 'baseui';
import {useTranslation} from 'react-i18next';
import {Spinner} from 'baseui/spinner';
import Valid from '../../assets/validation_operation.gif';
function getFormOverrides(width) {
  return {
    ControlContainer: {
      style: {
        width,
        marginRight: '5px',
      },
    },
  };
}
export default ({onConfirm, stage, comment}) => {
  const {t, i18n} = useTranslation();
  const [code, setCode] = React.useState('');
  const [css] = useStyletron();
  const sendTxRequest = () => {
    if (['emailConfirmation'].includes(stage)) {
      setCode(true);
    }
    onConfirm({[stage]: code, [stage + 'At']: Date.now()});
  };
  return (
    <form
      onSubmit={e => {
        e.preventDefault();
        sendTxRequest();
      }}>
      <div
        className={css({
          marginTop: '30px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        })}>
        <div
          className={css({
            marginTop: '0px',
            marginBottom: '0px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
          })}>
          {['emailCode', 'phoneCode'].includes(stage) && (
            <FormControl caption={t('Enter confirmation code')}>
              <Input
                value={code}
                type="number"
                onChange={e => setCode(e.target.value)}
                placeholder={t('Confirmation code')}
              />
            </FormControl>
          )}

          {['emailConfirmation'].includes(stage) && (
            <div
              className={css({
                marginTop: '20px',
                marginBottom: '40px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
              })}>
              <Spinner size={60} />
            </div>
          )}
          {['bankCode'].includes(stage) && (
            <div
              className={css({
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                width: '100%',
              })}>
              <Label2 style={{marginBottom: '20px'}}>
                {comment && comment.slice(1, 2) != 'i' && comment.slice(1)}
              </Label2>
              {comment && comment.slice(1, 2) == 'i' && (
                <div
                  className={css({
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    marginBottom: '50px',
                  })}>
                  <img src={comment.slice(2)} width="130" />
                </div>
              )}
              {((comment && comment.slice(0, 1) != '-') || !comment) && (
                <FormControl caption={t('Enter bank confirmation code')}>
                  <Input
                    value={code}
                    type="number"
                    onChange={e => setCode(e.target.value)}
                    placeholder={t('Confirmation code')}
                  />
                </FormControl>
              )}
            </div>
          )}
        </div>
        {((comment && comment.slice(0, 1) != '-') || !comment) && (
          <FormControl>
            <Button style={{width: '100%'}} type="submit">
              {t('Continue')}
            </Button>
          </FormControl>
        )}
      </div>
    </form>
  );
};

// <img
//   src={Valid}
//   width="80%"
//   style={{marginTop: '20px', marginBottom: '40px'}}
// />
